module.exports = __webpack_public_path__ + "f1288a8c9acf2381c8c77c60445971a5.jpg";